// Mobilnav
    jQuery(document).ready(function($) {
    $("#mmenu").hide();
    $(".mtoggle").click(function() {
        $("#mmenu").slideToggle(250);
    });
    });
    


// Ã„ndrar class pÃ¥ navicon fÃ¶r mobilnav  
//<![CDATA[
$(window).load(function(){
$('.navicon').click(function() {
    if($(this).hasClass('button-open'))
    {
        $(this).addClass('button-closed').removeClass('button-open');
    }
    else
    {
       $(this).addClass('button-open').removeClass('button-closed');
    }
  });
});//]]>